<template>
  <div class="realtime-confirm-modal">
    <div class="content-wrapper">
      <div class="top-wrapper">
        <span class="title">{{ $t('heatmap.realtime.changeConfirm.title') }}</span>
        <span class="desc" v-html="$t('heatmap.realtime.changeConfirm.desc') "></span>
      </div>
      <div class="bottom-wrapper">
        <div class="current">
          <span class="text">{{ $t('heatmap.realtime.changeConfirm.current') }}</span>
          <span class="report">{{ data.current }}</span>
        </div>
        <div class="change">
          <span class="text">{{ $t('heatmap.realtime.changeConfirm.change') }}</span>
          <span class="report">{{ data.change }}</span>
        </div>
      </div>
      <div class="btn-wrapper">
        <ui-button :class="$i18n.locale" @click="onClose('cancel')">
          {{ $t('common.cancel') }}
        </ui-button>
        <ui-button :primary="true" @click="onClose('change')">
          {{ $t('referral.register.confirm') }}
        </ui-button>
      </div>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton.vue'

export default {
  name: 'HeatmapRealtimeConfirm',
  components: { UiButton },
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  methods: {
    onClose (value) {
      this.$close(value)
    }
  }
}

</script>

<style lang="scss" scoped>
.realtime-confirm-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.50);
  z-index: 99;

  .content-wrapper {
    @include flexYcenter
    position: absolute;
    top: 50%;
    left: 50%;
    background: #fff;
    transform: translate(-50%, -50%);
    width: 428px;
    padding: 48px 28px 24px 28px;
    flex-direction: column;
    gap: 12px;
    border-radius: 14px;
    box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.16);
    box-sizing: border-box;

    .top-wrapper {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-bottom: 12px;

      .title {
        color: #444;
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        line-height: 120%; /* 24px */
      }

      .desc {
        color: #2F2F2F;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 150%; /* 21px */
      }
    }

    .bottom-wrapper {
      width: 100%;
      display: flex;
      padding: 20px;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      border-radius: 5px;
      border: 1px solid #D7D7D7;
      background: #F4F4F4;
      box-sizing: border-box;
      color: #2F2F2F;

      .text {
        font-size: 15px;
        font-weight: 600;
        line-height: 100%; /* 15px */
      }

      .report {
        font-size: 13px;
        font-weight: 400;
        line-height: 150%; /* 19.5px */
        padding-left: 8px;
      }

      .current, .change {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .current {
        border-bottom: 1px dashed #aaa;
        padding-bottom: 18px;
      }

      .change {
        margin-top: 10px;
        .text {
          color: #ec0047;
        }
      }
    }

    .btn-wrapper {
      @include flexYcenter;
      gap: 4px;

      & /deep/ .ui-btn {
        width: 90px;

        &.ja {
          width: initial;
        }
      }
    }
  }
}
</style>
